import { render } from "./checkoutLayout.vue?vue&type=template&id=2120dfd3&scoped=true&ts=true"
import script from "./checkoutLayout.vue?vue&type=script&lang=ts"
export * from "./checkoutLayout.vue?vue&type=script&lang=ts"

import "./checkoutLayout.vue?vue&type=style&index=0&id=2120dfd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2120dfd3"]])

export default __exports__